export const APPLICATION_CONFIG = {
    isOpen: false,
    period: {
        start: '2025-02-20',
        end: '2025-03-08'
    },
    message: {
        closed: '지원 기간이 아닙니다.',
    }
};